export * from "./store";

export type BlogType = {
  image: string;
  title: string;
  blogUrl: string;
  date: string;
};
export enum COMMENT_TYPE {
  YAWAKIT_COMMENT = "YAWAKIT_COMMENT",
  GOOGLE_COMMENT = "GOOGLE_COMMENT",
  FACEBOOK_COMMENT = "FACEBOOK_COMMENT",
}
export type FormattedCommentType = {
  id: string;
  images?: string[];
  userProfilePicture: string;
  fullName: string;
  date: string;
  comment: string;
  rating?: number;
  commentImage?: { url: string; name: string; width: number; height: number };
};
